import { BORDERS, COLORS } from '@alto/design-library-tokens';
import { Border, H3, MdPadding, PressableAltoIcon, Row, getBrand } from '@alto/design-system';
import React from 'react';
import { useCartData } from '~shared/features/cart/hooks/useCartData';

type Props = {
  readonly onClose: () => void;
};

const getBackgroundColor = () => {
  const brand = getBrand();
  if (brand === 'fuzehealth' || brand === 'fuzerx') {
    return COLORS.BACKGROUND_COLORS.WHITE;
  }
  return COLORS.BACKGROUND_COLORS.GREY_LIGHTER;
};

export const CartItemHeader = ({ onClose }: Props) => {
  const { cartSize } = useCartData();

  return (
    <Border
      hideLeft
      hideRight
      hideTop
      noBottomLeftRadius
      noBottomRightRadius
    >
      <MdPadding
        backgroundColor={getBackgroundColor()}
        style={{ borderTopLeftRadius: BORDERS.RADIUS.LG.value, borderTopRightRadius: BORDERS.RADIUS.LG.value }}
      >
        <Row spaceBetween>
          <H3 color={COLORS.TEXT_COLORS.BLACK}>Your Cart {cartSize > 0 ? `(${cartSize})` : ''}</H3>
          <PressableAltoIcon
            name="close"
            accessibilityLabel="Press to close cart"
            type="grey"
            onPress={onClose}
          />
        </Row>
      </MdPadding>
    </Border>
  );
};
